export interface Score {
  scoreId?: number
  title: string
  artist: string
  genre: string
  status: string
  hidden: boolean
  levels: string[]
  freeLevels: string[]
  plays: number
  featured: string
  registered: string
  lastPlayed: string
  updated: string
}

export const difficultyLabels = ['Easy', 'Normal', 'Hard']

export const scoreCategories = ['트로트', '가요', '동요', '팝']

export const scoreFormats = ['컬러드럼악보', '컬러오선악보', '오선악보']

export const defaultScoreFormatsByDifficulty = ['컬러드럼악보', '컬러오선악보', '오선악보']

export const scores: Score[] = [
  { title: '찔레꽃', artist: '백난아', genre: '트로트', status: '공개', hidden: false, levels: ['Easy', 'Normal', 'Hard'], freeLevels: ['Easy'], plays: 2841, featured: '추천', registered: '2026-07-02', lastPlayed: '2026-07-28 09:12', updated: '2026-07-26' },
  { title: '아리랑', artist: '민요', genre: '가요', status: '공개', hidden: false, levels: ['Easy', 'Normal', 'Hard'], freeLevels: [], plays: 2390, featured: '-', registered: '2026-07-05', lastPlayed: '2026-07-28 08:54', updated: '2026-07-27' },
  { title: '고향의 봄', artist: '동요', genre: '동요', status: '공개', hidden: false, levels: ['Easy', 'Normal', 'Hard'], freeLevels: ['Easy', 'Normal'], plays: 1944, featured: '추천', registered: '2026-06-28', lastPlayed: '2026-07-27 17:20', updated: '2026-07-21' },
  { title: 'My Way', artist: 'Frank Sinatra', genre: '팝', status: '미공개', hidden: true, levels: ['Easy', 'Normal', 'Hard'], freeLevels: [], plays: 0, featured: '-', registered: '2026-07-12', lastPlayed: '-', updated: '2026-07-12' },
]

export const scoresSpecification = {
  title: '악보관리',
  purpose: '드럼 악보의 등록, 사용자 노출, 무료 회원 이용 범위를 관리합니다.',
  functions: [
    '상단 ‘악보 등록’에서 곡명·가수·장르와 Easy·Normal·Hard 3개 악보를 등록합니다.',
    '각 행의 ‘수정’에서 곡 정보, 사용자 공개/미공개, 난이도별 무료 회원 이용 여부를 수정합니다.',
    '체크박스로 여러 곡을 선택해 무료 회원 이용 범위를 일괄 설정하거나 미공개·삭제 처리합니다.',
    '공개/미공개는 사용자 앱에서 곡 자체를 보일지 결정합니다. 무료 회원 이용 설정은 공개 곡 중 무료 회원이 연주할 난이도를 정합니다.',
  ],
  connections: [
    '난이도 이름은 설정 > 난이도 수정에서 변경하며, 변경된 이름은 목록·등록·수정·사용자 앱 표기에 함께 적용됩니다.',
    '카테고리는 설정 > 악보 카테고리 관리에서 등록·수정·순서 변경·삭제합니다. 카테고리를 삭제하면 해당 곡은 미공개 처리됩니다.',
    '악보 미리보기는 실제 악보 렌더링 결과를 새 창에서 확인하고, 악보로그는 여기서 관리하는 곡별 플레이 수와 상세 이력을 사용합니다.',
  ],
  app: '공개 곡만 사용자 악보 목록에 노출됩니다. 미공개 곡은 무료·유료 사용자 모두에게 노출되지 않습니다.',
}

export const scoresDataModelGuide = [
  '악보 키: score_id, 카테고리 키: score_category_id',
  '난이도 모델: score_id + difficulty_code(Easy/Normal/Hard)별 ABC 코드·형식·무료 회원 이용 여부',
  '공개 상태는 score.publish_status, 무료 회원 이용은 difficulty.free_access로 분리 저장합니다.',
]

export const scoresImplementationGuide = [
  '화면 식별자: scores. 좌측 사이드 메뉴는 유지하고 메인 영역만 전환합니다.',
  '필수 데이터: 곡명, 가수, 카테고리, 공개 상태, 3개 난이도 악보, 무료 회원 이용 난이도, 등록일, 플레이 수.',
  '검색, 카테고리, 노출, 무료 회원 이용, 기간 조건을 목록과 집계 카드에 반영합니다.',
  '일괄 처리와 곡별 수정은 공개 상태와 무료 회원 이용 난이도를 분리 저장합니다.',
  '현재 화면은 운영 UI 목업입니다. 실제 개발에서는 API 응답, 저장 성공·실패, 권한 오류, 빈 목록 상태를 별도로 구현해야 합니다.',
]

export const scoresStateDefinitions: [string, string, string][] = [
  ['공개', '사용자 앱 악보 목록에 노출', '무료 회원은 허용 난이도만, 드럼 유료 회원은 전체 난이도 이용'],
  ['미공개', '사용자 앱 악보 목록에서 제외', '무료·유료 회원 모두 이용 불가'],
  ['무료 회원 이용 허용', '공개 곡의 난이도별 접근값', '드럼 유료 권한이 없는 회원에게 해당 난이도 허용'],
]
